module.exports = __webpack_public_path__ + "img/uld-dwn-arr.517dd1f9.svg";